import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateTrackableItemMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  update: Types.UpdateTrackableItem;
}>;


export type UpdateTrackableItemMutation = { __typename?: 'Mutation', updateTrackableItem: { __typename?: 'TrackableItem', id: string, name: string, epc_tag: string, item_type: { __typename?: 'ItemType', id: number, name: string, image_url?: string | null, color_hex_code?: string | null, category: Types.ItemTypeCategory, archived: boolean } } };


export const UpdateTrackableItemDocument = gql`
    mutation UpdateTrackableItem($id: ID!, $update: UpdateTrackableItem!) {
  updateTrackableItem(id: $id, update: $update) {
    id
    name
    epc_tag
    item_type {
      id
      name
      image_url
      color_hex_code
      category
      archived
    }
  }
}
    `;
export type UpdateTrackableItemMutationFn = Apollo.MutationFunction<UpdateTrackableItemMutation, UpdateTrackableItemMutationVariables>;

/**
 * __useUpdateTrackableItemMutation__
 *
 * To run a mutation, you first call `useUpdateTrackableItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackableItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackableItemMutation, { data, loading, error }] = useUpdateTrackableItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateTrackableItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrackableItemMutation, UpdateTrackableItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrackableItemMutation, UpdateTrackableItemMutationVariables>(UpdateTrackableItemDocument, options);
      }
export type UpdateTrackableItemMutationHookResult = ReturnType<typeof useUpdateTrackableItemMutation>;
export type UpdateTrackableItemMutationResult = Apollo.MutationResult<UpdateTrackableItemMutation>;
export type UpdateTrackableItemMutationOptions = Apollo.BaseMutationOptions<UpdateTrackableItemMutation, UpdateTrackableItemMutationVariables>;